module.exports = __webpack_public_path__ + "static/media/logo_vietcapital.018cbb89.svg";